export enum ContactUsField {
  name = "name",
  phone = "phone",
  email = "email",
  question = "question",
}

export type ContactUsValues = {
  [ContactUsField.name]: string;
  [ContactUsField.phone]: string;
  [ContactUsField.email]: string;
  [ContactUsField.question]: string;
};
